import type { SxProps, Theme } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import type { MouseEvent } from "react";
import DocumentSearchIcon from "@entrilia/shared/icons/DocumentSearchIcon";

interface Props {
  active?: boolean;
  tooltip?: string;
  onClick?: () => void;
}

// Not `disabled`: that would grey out the active highlight and suppress the tooltip.
const nonClickableSx: SxProps<Theme> = { cursor: "default", "&:hover": { backgroundColor: "transparent" } };

const FieldCitationButton = ({ active, tooltip, onClick }: Props) => {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick?.();
  };

  return (
    <Tooltip arrow title={tooltip}>
      <IconButton
        color={active ? "primary" : "secondary"}
        aria-disabled={!onClick}
        disableRipple={!onClick}
        sx={onClick ? undefined : nonClickableSx}
        onClick={handleClick}
      >
        <DocumentSearchIcon />
      </IconButton>
    </Tooltip>
  );
};

export default FieldCitationButton;
